import React, { Component } from 'react'

import {Droppable} from "react-beautiful-dnd";
import PortalAdminRole from "./PortalAdminRole";

import  sAction  from "sAction";

class PortalAdminCompany extends React.Component {


    render(){
        
        const data = this.props.data;
        const roles = data.roles;

        const bClass = data.type == "root" ? " rootBranch" : "";
        return <div id={"company"+data.id} className="portalAdminCompany">
            <div className={"portalAdminCompanyHeader"+bClass}>
                <span className="dragableItemIcon icon-folder" />
                {data.name}
            </div>
            <Droppable droppableId={data.id} type="ROLES">
            {(provided, snapshot) => (
            <div
                className={"portalAdminRolesDropzone portalDropZone"+(snapshot.isDraggingOver ? " isDragOver" : "")}
                ref={provided.innerRef}
                {...provided.droppableProps}
            >
                <div>
                {
                    Object.keys(roles).map((key, index) => 
                        <PortalAdminRole 
                            roleId={data.id+"_"+roles[key].id}
                            key={roles[key].id} 
                            data={roles[key]}
                            deleteUser={this.props.deleteUser}
                            deleteRole={this.props.deleteRole}
                            bId={this.props.bId}
                        />
                )
                    
                }
                </div>
                {provided.placeholder}
            </div> 

            )}
            </Droppable>
        </div>;
    }

}
export default PortalAdminCompany